import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    business: {},
    warehouseProducts: [],
    groupedData: [],
    summary: {
      totalManufacturingUnits: 0,
      totalProducts: 0,
      totalQuantity: 0,
      totalValue: 0,
      statusBreakdown: {},
    },
  },
  loading: false,
  error: null,
};

const warehouseReportSlice = createSlice({
  name: "WarehouseReport",
  initialState,
  reducers: {
    WarehouseReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    WarehouseReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload; // payload contains { business, warehouseProducts, groupedData, summary }
    },
    WarehouseReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export actions and reducer
export const {
  WarehouseReportRequest,
  WarehouseReportSuccess,
  WarehouseReportFailure,
} = warehouseReportSlice.actions;

export default warehouseReportSlice.reducer;